import styles from "./MyMedal.module.less";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CommonNavBar from "views/components/CommonNavBar";
import { getMedalJourney, gitShareModalImage } from "api/mine";
import { Toast } from "react-vant";
import { showMedalShare } from "./MedalShare";

const MyMedal = () => {
  const navigate = useNavigate();
  const [journeyData, setJourneyData] = useState([]);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const fetchJourneyData = async () => {
    Toast.loading({
      message: "加载中...",
      forbidClick: false,
      duration: 0,
    });
    try {
      const res = await getMedalJourney();
      if (res.code === 200 && res.data) {
        setJourneyData(res.data.year_groups || []);
      }
    } catch (error) {
      console.error("Failed to fetch medal journey data:", error);
    } finally {
      Toast.clear();
    }
  };

  useEffect(() => {
    fetchJourneyData();
  }, []);

  const handleShare = async () => {
    const allItems = journeyData.reduce(
      (acc, group) => [...acc, ...(group.list || [])],
      [],
    );
    if (allItems.length === 0) {
      Toast.info("暂无勋章");
      return;
    }

    const payload = {
      medal_layout: Math.min(allItems.length, 4),
    };

    for (let i = 0; i < Math.min(allItems.length, 4); i++) {
      payload[`medal_image${i + 1}`] = allItems[i].icon;
      payload[`medal_text${i + 1}`] = allItems[i].show_title;
    }

    Toast.loading({
      message: "正在生成分享...",
      forbidClick: false, // 允许用户点击返回按钮
      duration: 0,
    });

    try {
      const res = await gitShareModalImage(payload);
      if (!isMounted.current) {
        Toast.clear();
        return;
      }
      Toast.clear();

      if (res.code === 200 && res.data) {
        showMedalShare(res.data);
      } else {
        Toast.fail(res.message || "分享失败");
      }
    } catch (error) {
      if (!isMounted.current) {
        Toast.clear();
        return;
      }
      console.error("Share failed:", error);
      Toast.fail(error?.message || "分享失败");
    }
  };

  return (
    <div className={styles["my-medal-container"]}>
      <CommonNavBar
        title="我的勋章"
        onClickBack={() => navigate(-1)}
        backgroundColor="transparent"
        isTop={true}
        rightContent={
          <img
            className={styles["nav-share-icon"]}
            src={require("@/images/mine/my-medal/share-icon-2.png")}
            alt="share"
            onClick={handleShare}
          />
        }
      />
      <div className={styles["top-section"]}>
        <img
          className={styles["top-bg"]}
          src={require("@/images/mine/my-medal/my-top.png")}
          alt="top bg"
        />
        <img
          className={styles["top-bg-portrait"]}
          src={require("@/images/mine/my-medal/my-top-portrait.png")}
          alt="top bg portrait"
        />
        <img
          className={styles["top-bg-landscape"]}
          src={require("@/images/mine/my-medal/my-top-landscape.png")}
          alt="top bg landscape"
        />
        <div className={styles["top-content"]}>
          <div className={styles["info-wrapper"]}>
            <div className={styles["info-texts"]}>
              <div className={styles["accumulate-title"]}>累计获得（枚）</div>
              <div className={styles["accumulate-subtitle"]}>
                记录我的学习成就
              </div>
            </div>
            <div className={styles["accumulate-number"]}>
              {journeyData.reduce((sum, group) => sum + group.count, 0)}
            </div>
          </div>
        </div>
      </div>

      <div className={styles["list-container"]}>
        {/* Placeholder for the list structure based on the screenshot */}
        {journeyData.map((group, gIndex) => (
          <div key={gIndex} className={styles["list-group"]}>
            <div className={styles["group-title"]}>
              <span className={styles["group-title-text"]}>
                {group.year}年·{group.count}枚
              </span>
              <img
                className={styles["group-title-icon"]}
                src={require("@/images/mine/my-medal/my-item.png")}
                alt="icon"
              />
            </div>
            <div className={styles["list-section"]}>
              {group.list?.map((item) => (
                <div
                  key={item.log_id}
                  className={styles["medal-item"]}
                  onClick={() =>
                    navigate(
                      `/mine/medalDetail?category_id=${
                        item.category_id
                      }&show_level=${item.level || item.show_level}`,
                    )
                  }
                >
                  {item.is_new === 1 && (
                    <img
                      className={styles["new-icon"]}
                      src={require("@/images/mine/my-medal/new-icon.png")}
                      alt="new"
                    />
                  )}
                  <img
                    className={styles["medal-icon"]}
                    src={item.icon}
                    alt={item.show_title}
                  />
                  <div className={styles["medal-title"]}>{item.show_title}</div>
                  <div className={styles["medal-time"]}>
                    {item.obtained_text}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyMedal;
